<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>預約派車單總表</h3>
          <hr />
        </div>
      </div>
    </div>
    <div v-if="vx_activeTab === 'line'" class="row">
      <div class="col-md-5">
        <h4 class="col-md-4">
          <i class="fa fa-user" />
          預約單總數:
          <span class="red_textcolor">{{ vx_lineReserveTotal }}</span>
        </h4>
      </div>
    </div>
    <!-- filter -->
    <div class="row" style="margin-bottom: 1rem">
      <div
        v-show="vx_activeTab !== 'line'"
        class="col-md-7"
        style="display: flex"
      >
        <h4 class="col-md-3 fontSize20">搜尋關鍵字:</h4>
        <el-input
          class="search-placeholder-bold"
          v-model="kw"
          placeholder="呼號/隊編、乘客電話、車牌、備註等..."
          style="margin-right: 1rem"
        />
        <el-button class="search-btn" @click="onSearch">搜尋</el-button>
      </div>
      <!-- count down -->
      <div class="col-md-5">
        <h4 class="col-md-7 fontSize20">
          倒數：{{ time }}秒更新, 最後更新時間{{ vx_lastUpdatedTime }}
        </h4>
      </div>
    </div>
    <el-row v-show="vx_activeTab !== 'line'">
      <el-col :span="8" :offset="3">
        <el-radio-group v-model="rule" @input="onRule" class="pick">
          <el-radio :label="0">查全部</el-radio>
          <el-radio :label="1">只查呼號</el-radio>
          <el-radio :label="2">只查電話</el-radio>
          <el-radio :label="3">只查車牌</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <div class="row" style="margin-bottom: 1rem">
      <div class="col-md-5" style="display: flex">
        <h4 class="col-md-3 fontSize20" style="margin-right: 1rem">
          目前進度:
        </h4>
        <el-select v-model="currentStatus" @change="onCurrentStatus">
          <el-option
            v-for="option in CURRENT_STATUS_OPTIONS"
            :key="option.value"
            :value="option.value"
            :label="option.label"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_content">
          <!-- tab select -->
          <ul class="nav nav-tabs fontSize20" id="myTab" role="tablist">
            <li class="nav-item" :class="{ active: vx_activeTab === 'team' }">
              <a
                class="nav-link"
                href="#team"
                role="tab"
                data-toggle="tab"
                @click="onTab('team')"
              >
                車隊專屬預約單
              </a>
            </li>
            <li class="nav-item" :class="{ active: vx_activeTab === 'line' }">
              <a
                class="nav-link"
                href="#line"
                role="tab"
                data-toggle="tab"
                @click="onTab('line')"
              >
                Line 網路預約
              </a>
            </li>
            <li
              class="nav-item"
              :class="{ active: vx_activeTab === 'airport' }"
              v-if="isShowAirportTab"
            >
              <a
                class="nav-link"
                href="#airport"
                role="tab"
                data-toggle="tab"
                @click="onTab('airport')"
              >
                機場預約
              </a>
            </li>
          </ul>
          <el-row
            :gutter="12"
            type="flex"
            align="middle"
            style="margin: 1rem 0"
          >
            <el-col :span="2">
              <el-select v-model="npp" @change="onNpp">
                <el-option
                  v-for="npp in [10, 25, 50, 100]"
                  :key="npp"
                  :value="npp"
                  :label="npp"
                />
              </el-select>
            </el-col>
            <el-col v-show="vx_activeTab === 'line'">
              <h4 class="fontSize20" style="font-weight: 600">
                顯示前三個月之後的預約單
              </h4>
            </el-col>
            <el-col v-show="vx_activeTab === 'team'" :span="15">
              <el-radio-group class="pick" v-model="teamTask" @input="onRadio">
                <el-tooltip
                  effect="dark"
                  content="前2小時之後的預約單"
                  placement="top-start"
                >
                  <el-radio label="all">
                    顯示最近訂單
                    <span style="color: red">({{ vx_recentTotal }})</span>
                  </el-radio>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="顯示一小時內，尚未配對的訂單"
                  placement="top-start"
                >
                  <el-radio label="nonAssign">
                    未配對訂單
                    <span style="color: red">({{ vx_nonmatchTotal }})</span>
                  </el-radio>
                </el-tooltip>
                <el-radio label="limitTime">
                  預約時間一小時內
                  <span style="color: red">({{ vx_reserveTotal }})</span>
                </el-radio>
              </el-radio-group>
            </el-col>
            <el-col v-show="vx_activeTab === 'airport'" :span="15">
              <el-radio-group
                class="pick"
                v-model="airportTask"
                @input="onAirportRadio"
              >
                <el-tooltip
                  effect="dark"
                  content="從現在時間算起+72小時"
                  placement="top-start"
                >
                  <el-radio label="airport_recent">
                    顯示三天內訂單
                    <span style="color: red">({{ vx_recentTotal }})</span>
                  </el-radio>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="顯示一小時內，尚未配對的訂單"
                  placement="top-start"
                >
                  <el-radio label="airport_unpair">
                    未配對訂單
                    <span style="color: red">({{ vx_nonmatchTotal }})</span>
                  </el-radio>
                </el-tooltip>
                <el-radio label="airport_hour">
                  顯示一小時內訂單
                  <span style="color: red">({{ vx_reserveTotal }})</span>
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <!-- tabs -->
          <div class="tab-content">
            <Team @openModal="openModal" />
            <LineApp @openModal="openModal" />
            <AirportTable @openModal="openModal" />
          </div>
        </div>
      </div>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :current-page="currentPage"
            :page-count="totalPages"
          />
        </el-col>
      </el-row>
    </div>
    <ReserveModal ref="reserveDetailModal" />
    <AirportReserveModal ref="airportReserveModal" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { currentStatusOptions } from '@/constants/select'
import { Team, LineApp, AirportTable } from './components'
import ReserveModal from '@/components/reserveModal'
import AirportReserveModal from '@/components/reserveModal/Airport'
import { hasTeamRole } from '@/utils/teamRoleAuth'

export default {
  components: {
    Team,
    LineApp,
    AirportTable,
    ReserveModal,
    AirportReserveModal,
  },
  data() {
    return {
      /* filter */
      rule: 0,
      teamTask: 'nonAssign',
      airportTask: 'airport_recent',
      currentStatus: null,
      npp: 25,
      kw: '',
      nonAssginTotal: 0,
      nonReplyTotal: 0,
      /* count down */
      time: 15,
      intervalId: null,
      /* paging */
      teamTotalPages: 1,
      lineTotalPages: 1,
      airportTotalPages: 1,
      teamCurrentPage: 1,
      lineCurrentPage: 1,
      airportCurrentPage: 1,
    }
  },
  methods: {
    /* 預約單列表 */
    ...mapMutations('reservation', {
      vx_setActiveTab: 'setActiveTab',
      vx_setTask: 'setTask',
      vx_setRule: 'setRule',
      vx_setCurrentStatus: 'setCurrentStatus',
      vx_setKw: 'setKw',
      vx_setTeamPagingCurrentPage: 'setTeamPagingCurrentPage',
      vx_setLinePagingCurrentPage: 'setLinePagingCurrentPage',
      vx_setAirportPagingCurrentPage: 'setAirportPagingCurrentPage',
      vx_setTeamPagingNpp: 'setTeamPagingNpp',
      vx_setLinePagingNpp: 'setLinePagingNpp',
      vx_setAirportPagingNpp: 'setAirportPagingNpp',
    }),
    ...mapActions('reservation', {
      vx_fetchList: 'fetchList',
    }),
    /* 單筆預約單modal */
    ...mapMutations('reserveModal', {
      vx_initModal: 'init',
      vx_setModalId: 'setId',
      vx_setOpenAt: 'setOpenAt',
      vx_mergeBillInfoFromList: 'mergeBillInfoFromList',
    }),
    ...mapActions('reserveModal', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
      vx_fetchServiceList: 'fetchServiceList',
    }),
    async openModal(payload) {
      try {
        this.vx_initModal()
        let listItem = null
        let id = payload
        if (payload && typeof payload === 'object') {
          listItem = payload
          id =
            (payload.billInfo && payload.billInfo.orderId) ||
            payload.orderId ||
            payload
        }
        this.vx_setModalId(id)
        await this.vx_fetchOrderDetail()
        if (
          listItem &&
          listItem.billInfo &&
          listItem.billInfo.reservationType === 2
        ) {
          this.vx_mergeBillInfoFromList({
            billInfo: listItem.billInfo || {},
            driverInfo: listItem.driverInfo || {},
          })
        }
        // 根據 reservationType 決定開啟哪個 modal
        const billInfo = this.$store.state.reserveModal.billInfo
        if (billInfo && billInfo.reservationType === 2) {
          // 機場接送
          this.$refs.airportReserveModal.openModal()
        } else {
          // 一般預約
          this.$refs.reserveDetailModal.openModal()
        }
      } catch (e) {
        console.error(e)
      }
    },
    toPageOne() {
      this.vx_setTeamPagingCurrentPage(1)
      this.vx_setLinePagingCurrentPage(1)
      this.vx_setAirportPagingCurrentPage(1)
    },
    onCurrentStatus() {
      this.vx_setCurrentStatus(this.currentStatus)
      this.vx_fetchList()
    },
    onTab(tab) {
      this.vx_setActiveTab(tab)
      if (tab === 'line') {
        this.vx_setTask('internet')
      } else if (tab === 'airport') {
        this.vx_setTask(this.airportTask || 'airport_recent')
      } else {
        this.vx_setTask(this.teamTask)
      }
      this.vx_fetchList()
    },
    onNpp(npp) {
      if (this.vx_activeTab === 'line') {
        this.vx_setLinePagingNpp(npp)
      } else if (this.vx_activeTab === 'airport') {
        this.vx_setAirportPagingNpp(npp)
      } else {
        this.vx_setTeamPagingNpp(npp)
      }
      this.toPageOne()
      this.vx_fetchList()
    },
    onRadio(teamTask) {
      this.vx_setTask(teamTask)
      this.toPageOne()
      this.vx_fetchList()
    },
    onAirportRadio(task) {
      this.airportTask = task
      this.vx_setTask(task)
      this.toPageOne()
      this.vx_fetchList()
    },
    onSearch() {
      this.vx_setKw(this.kw)
      this.toPageOne()
      this.vx_fetchList()
    },
    onRule() {
      this.vx_setRule(this.rule)
    },
    onPageChange(currentPage) {
      if (this.vx_activeTab === 'team') {
        this.vx_setTeamPagingCurrentPage(currentPage)
      } else if (this.vx_activeTab === 'airport') {
        this.vx_setAirportPagingCurrentPage(currentPage)
      } else {
        this.vx_setLinePagingCurrentPage(currentPage)
      }
      this.vx_fetchList()
    },
    countDown() {
      const newTime = this.time - 1
      if (newTime < 0) {
        this.time = 15
        this.vx_fetchList()
      } else {
        this.time = newTime
      }
    },
  },
  computed: {
    // 判斷是否顯示機場接送選項
    isShowAirportTab() {
      return hasTeamRole('airport_transfer')
    },
    ...mapState('reservation', {
      vx_activeTab: 'activeTab',
      vx_lastUpdatedTime: 'lastUpdatedTime',
      vx_reserveTotal: 'reserveTotal',
      vx_nonAssignTotal: 'nonAssignTotal',
      vx_nonReplyTotal: 'nonReplyTotal',
      vx_recentTotal: 'recentTotal',
      vx_nonmatchTotal: 'nonmatchTotal',
      vx_reserveTotal: 'reserveTotal',
      vx_lineReserveTotal: 'lineReserveTotal',
      vx_teamPaging: 'teamPaging',
      vx_linePaging: 'linePaging',
    }),
    totalPages() {
      if (this.vx_activeTab === 'line') {
        return this.lineTotalPages
      } else if (this.vx_activeTab === 'airport') {
        return this.airportTotalPages
      }
      return this.teamTotalPages
    },
    currentPage() {
      if (this.vx_activeTab === 'line') {
        return this.lineCurrentPage
      } else if (this.vx_activeTab === 'airport') {
        return this.airportCurrentPage
      }
      return this.teamCurrentPage
    },
  },
  async mounted() {
    // 未配對訂單
    await this.vx_fetchList()
    // 全部訂單
    this.vx_setTask('all')
    this.teamTask = 'all'
    await this.vx_fetchList()
    this.vx_setOpenAt('預約單')
    this.intervalId = setInterval(this.countDown, 1000)
  },
  created() {
    this.vx_fetchServiceList()
    this.CURRENT_STATUS_OPTIONS = currentStatusOptions
    this.unwatchTeamPaging = this.$store.watch(
      (state) => state.reservation.teamPaging,
      (newPaging) => {
        this.teamTotalPages = newPaging.totalPages
        this.teamCurrentPage = newPaging.currentPage
      },
      {
        deep: true,
      },
    )
    this.unwatchLinePaging = this.$store.watch(
      (state) => state.reservation.linePaging,
      (newPaging) => {
        this.lineTotalPages = newPaging.totalPages
        this.lineCurrentPage = newPaging.currentPage
      },
      {
        deep: true,
      },
    )
    this.unwatchAirportPaging = this.$store.watch(
      (state) => state.reservation.airportPaging,
      (newPaging) => {
        this.airportTotalPages = newPaging.totalPages
        this.airportCurrentPage = newPaging.currentPage
      },
      {
        deep: true,
      },
    )
  },
  beforeDestroy() {
    this.unwatchTeamPaging()
    this.unwatchLinePaging()
    this.unwatchAirportPaging()
    clearInterval(this.intervalId)
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/reservation/ReservationList.vue